import {
  formatNumberBasedOnValue,
  returnDecimalFormatting,
} from "@/lib/globalFormatterHelper";
import { toast } from "react-toastify";

export function truncateValueIfNeeded(value: any, notation: any) {
  if (value.includes(".")) {
    if (value.includes(".")) {
      const splits = value.split("."); //splits will only have 2 options. 2nd will be after the .
      const maxNumberOfDecimalPlaces = formatNumberBasedOnValue(notation);
      const numOfValuesAfterDecimal = splits[1].length;

      if (numOfValuesAfterDecimal > maxNumberOfDecimalPlaces) {
        const valueAsNumber = Number(value);
        const valueToDisplay = returnDecimalFormatting(valueAsNumber, notation);
        return valueToDisplay;
      }
    }
  }
  return value;
}

export function enforceRoundingOnDecimalValues(
  event: React.ChangeEvent<HTMLInputElement>,
  input: string,
  notation: any,
): boolean {
  const inputEvent = event.nativeEvent as InputEvent;

  if (input.includes(".")) {
    const splits = input.split("."); //splits will only have 2 options. 2nd will be after the .
    const maxNumberOfDecimalPlaces = formatNumberBasedOnValue(notation);
    const numOfValuesAfterDecimal = splits[1].length;

    // Early retrun to prevent setting value (cut of the user from entering more values.)
    if (numOfValuesAfterDecimal > maxNumberOfDecimalPlaces) {
      if (inputEvent.inputType == "insertFromPaste") {
        toast.error(
          `Maximum of ${maxNumberOfDecimalPlaces} decimal places allowed for ${notation} input.`,
        );
        return true;
      }
      if (inputEvent.inputType != "deleteContentBackward") {
        // Allow backspaces to be entered.
        return true;
      }
    }
  }
  return false;
}

export function checkQuoteNumberSize(
  event: React.ChangeEvent<HTMLInputElement>,
  input: string,
  maxValue: number = 9999999,
): boolean {
  const inputEvent = event.nativeEvent as InputEvent;
  if (Number(input) > maxValue || Number(input) < -maxValue) {
    if (inputEvent.inputType == "insertFromPaste") {
      toast.error(`Value entered is too large.`);
    }
    return true;
  }
  return false;
}
